export const CONTACT_EMAIL = 'product@mcgovern.org';

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/mcgovern-foundation/',
  instagram: 'https://www.instagram.com/pjmfdn/',
  x: 'https://x.com/PJMFdn',
  bsky: 'https://bsky.app/profile/pjmfdn.bsky.social',
  youtube: 'https://www.youtube.com/@patrickjmcgovernfoundation',
  website: 'https://www.mcgovern.org',
} as const;
